import React from 'react';
import PropTypes from 'prop-types';

const Identity = ({ identity, type }) => {
  let text = identity;
  if (type === 1 && identity.length === 12) {
    text = `${identity.substring(0, 6)}-${identity.substring(6, 8)}-${identity.substring(8, 13)}`;
  }
  return (
    <span>{text}</span>
  );
};

Identity.propTypes = {
  identity: PropTypes.string,
  type: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

export default Identity;



// WEBPACK FOOTER //
// ./src/components/Identity.jsx